'use strict'

angular
  .module('basalteApp')
  .constant('BAS_MUSIC_WIDGET', {
    EVT_VIEW_CHANGED: 'evtBasMusicWidgetViewChanged'
  })
